import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
  },
  cart: {
    flex: 0.7,
    marginBottom: spacing(3),
  },
  summary: {
    marginTop: spacing(10),
    flex: 0.3,
    maxWidth: "30%",
    gap: spacing(2),
    flexDirection: "column",
    "& > *": {
      maxWidth: "100%",
      width: "100%",
    },
    marginBottom: spacing(5),
  },
  container: {
    maxWidth: "70%",
    flex: 0.7,
    marginRight: spacing(3),
  },
  horizontalStepper: {
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
  },
}));
